import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import Search, { SearchProps } from './Search';

export interface SelectionDialogProps {
    open: boolean;
    onClose: () => void;
    title: string | React.ReactNode;
    toolbar?: React.ReactNode;
    actions?: React.ReactNode;
    children: React.ReactNode;
    searchProps?: SearchProps;
}

const SelectionDialog = (props: SelectionDialogProps) => {
    const { children, title, toolbar, actions, open, onClose, searchProps } =
        props;

    return (
        <Dialog
            PaperProps={{
                sx: {
                    backgroundColor: 'surfaceContainerLow.main',
                    minHeight: 'calc(100% - 64px)',
                },
            }}
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogTitle>
                {searchProps && (
                    <Box display="flex" justifyContent="center">
                        <Search
                            size="medium"
                            sx={{ width: 400 }}
                            // key={title + searchValue}
                            {...searchProps}
                            // initialValue={searchValue}
                            // onSubmit={value =>
                            //     navigate({
                            //         search: prev => ({
                            //             ...prev,
                            //             search: value || undefined,
                            //         }),
                            //     })
                            // }
                        />
                    </Box>
                )}
            </DialogTitle>
            <DialogContentText>{toolbar}</DialogContentText>
            <DialogContent sx={{ borderRadius: 4 }}>{children}</DialogContent>
            <DialogActions>{actions}</DialogActions>
        </Dialog>
    );
};

export default SelectionDialog;
